export default "__VITE_ASSET__DbAjYbcF__"